/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */

import { DefaultEventsMap } from '@socket.io/component-emitter';
import React from 'react';
import { Socket } from 'socket.io-client/build/esm/socket';

import { cn } from '@/utils';

type HighlighterOverlayProps = {
    socket: Socket<DefaultEventsMap, DefaultEventsMap>;
    panelOpen: boolean;
};

const HighlighterOverlay = ({ socket, panelOpen }: HighlighterOverlayProps) => {
    const handleWheel = (e: React.WheelEvent) => {
        const x = e.nativeEvent.offsetX;
        const y = e.nativeEvent.offsetY;
        const rect = e.currentTarget.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;
        const xPercent = x / width;
        const yPercent = y / height;
        const coordX = xPercent * 1280;
        const coordY = yPercent * 720;

        socket.emit('remoteControl', {
            eventType: 'wheel',
            event: {
                deltaX: e.deltaX,
                deltaY: e.deltaY,
                originX: coordX,
                originY: coordY,
            },
        });
    };

    return (
        <div
            className={cn(
                'absolute aspect-[16/9] overflow-y-scroll',
                panelOpen
                    ? 'bottom-0 top-0 left-[calc((100%_-_300px)_/_2)] w-full max-w-[calc(100%_-_300px)] -translate-x-1/2'
                    : 'inset-0',
            )}
            style={{
                cursor: 'var(--cursor-style)',
            }}
            tabIndex={0}
            onClick={(e) => {
                // yes abs, subpx can lead to negative values
                const x = e.nativeEvent.offsetX;
                // yes abs, subpx can lead to negative values
                const y = e.nativeEvent.offsetY;

                const rect = e.currentTarget.getBoundingClientRect();
                const width = rect.width;
                const height = rect.height;
                const xPercent = x / width;
                const yPercent = y / height;
                const coordX = xPercent * 1280;
                const coordY = yPercent * 720;
                socket.emit('remoteControl', {
                    eventType: 'move',
                    event: { x: coordX, y: coordY },
                });
            }}
            onWheel={handleWheel}
            onMouseEnter={() => {
                document.body.style.overflow = 'hidden';
            }}
            onMouseLeave={() => {
                document.body.style.overflow = 'auto';
            }}
        />
    );
};

export default HighlighterOverlay;
